import gql from "graphql-tag";

const LIST = gql`
    query GetNoteDashData {
        NoOfnewPatient
        NoOfPatientOnLeave
        PatientAdmissionRatio {
            count
            status
        }
        NoOfPatientOnAdmission
        CountPatient
        NoOfOutPatient
        PatientGenderRatio {
            docs {
                count
                title
            }
        }
        PatientDocAvg {
            doc {
                avg
                total
            }
        }
        GetAdmissionStats {
            labels
            dataSets {
                label
                data
            }
        }
    }
`;
export { LIST };

export const DUE_CAREPLAN = gql`
    query GetDueCareplan($page: Int, $limit: Int) {
        GetDueCareplan(page: $page, limit: $limit) {
            docs {
                id
                desc
                evidence
                header {
                    dateCommenced
                    title
                    typePlan
                }
                patient {
                    id
                    name
                    email
                    profile_picture
                    hcn
                    dob
                }
                created_at
                evaluation {
                    nextDate
                }
            }
            page
            limit
            totalDocs
            nextPage
            prevPage
            totalPages
        }
    }
`;
export const TERMINATION_CAREPLAN = gql`
    query GetTerminationCareplan($page: Int, $limit: Int) {
        GetTerminableCareplan(page: $page, limit: $limit) {
            docs {
                id
                desc
                evidence
                header {
                    dateCommenced
                    title
                    typePlan
                }
                patient {
                    id
                    name
                    email
                    profile_picture
                    hcn
                    dob
                }
                created_at
                evaluation {
                    nextDate
                }
            }
            page
            limit
            totalDocs
            nextPage
            prevPage
            totalPages
        }
    }
`;
